export default __webpack_public_path__ + "static/media/authorized_1.eee5de98.png";